import type { LucideIcon, LucideProps } from 'lucide-react'
import { forwardRef } from 'react'

export const Iconmark: LucideIcon = forwardRef<SVGSVGElement, LucideProps>(({ size = 24, ...props }, ref) => {
  // Calculate height based on original aspect ratio (27/28)
  const height = (Number(size) * 27) / 28

  return (
    <svg
      ref={ref}
      width={size}
      height={height}
      viewBox="0 0 28 27"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_7475_16672)">
        <path
          d="M26.8063 9.88196C26.6655 8.81416 26.2645 7.74848 25.5177 6.95981C25.389 6.82369 25.1586 6.67803 25.024 6.52655C22.0532 4.74741 19.2348 2.46827 16.2629 0.721973C15.0362 0.0016313 13.9525 -0.142437 12.5494 0.125572C10.7787 0.463497 8.69876 1.11763 6.93339 1.60704C5.30521 2.05884 4.04408 2.29242 2.71304 3.42484C-1.22342 6.77178 0.386229 11.4853 0.0567786 16.0276C0.198199 17.3767 0.760701 18.597 1.81102 19.4641C4.8015 21.2406 7.62566 23.5261 10.6034 25.2904C13.4022 26.9488 16.1919 25.1585 19.0468 24.632C21.4419 24.8635 26.2454 27.9525 26.8095 23.8672L26.8063 9.88249V9.88196ZM24.4229 17.1902C24.2915 19.1007 22.97 20.9567 21.1517 21.5992C18.7592 22.444 15.9636 22.8343 13.5245 23.6119C11.9631 23.7877 11.0176 22.7687 10.9154 21.2718C10.7618 19.0224 11.034 16.5997 10.918 14.3317C11.4922 8.98153 17.8699 9.51438 21.7094 8.0149C23.1008 7.83958 24.1067 8.50431 24.3641 9.88779C24.3503 12.2506 24.5849 14.8401 24.4229 17.1902Z"
          fill="currentColor"
        />
        <path
          d="M20.4362 12.4298C20.6671 12.398 20.834 12.5183 20.8767 12.7679C20.8744 13.1945 20.9134 13.6619 20.8864 14.086C20.8647 14.431 20.6454 14.7658 20.3436 14.8817C19.9466 15.0342 19.4828 15.1047 19.078 15.245C18.8189 15.2768 18.6618 15.0929 18.645 14.8225C18.6195 14.4167 18.6648 13.9791 18.6453 13.5701C18.7406 12.6044 19.7989 12.7006 20.4358 12.4298H20.4362Z"
          fill="currentColor"
        />
        <path
          d="M17.0478 13.5592C17.2787 13.5274 17.4455 13.6477 17.4883 13.8973C17.486 14.3239 17.525 14.7912 17.498 15.2154C17.4763 15.5604 17.257 15.8952 16.9552 16.0111C16.5582 16.1636 16.0944 16.2341 15.6895 16.3744C15.4305 16.4062 15.2734 16.2223 15.2565 15.9519C15.231 15.5461 15.2764 15.1085 15.2569 14.6995C15.3521 13.7338 16.4105 13.83 17.0474 13.5592H17.0478Z"
          fill="currentColor"
        />
        <path
          d="M20.4362 15.8185C20.6671 15.7867 20.834 15.907 20.8767 16.1566C20.8744 16.5832 20.9134 17.0505 20.8864 17.4747C20.8647 17.8197 20.6454 18.1545 20.3436 18.2703C19.9466 18.4229 19.4828 18.4934 19.078 18.6337C18.8189 18.6655 18.6618 18.4816 18.645 18.2112C18.6195 17.8054 18.6648 17.3678 18.6453 16.9588C18.7406 15.993 19.7989 16.0893 20.4358 15.8185H20.4362Z"
          fill="currentColor"
        />
        <path
          d="M17.0478 16.9479C17.2787 16.9161 17.4455 17.0364 17.4883 17.286C17.486 17.7126 17.525 18.1799 17.498 18.6041C17.4763 18.9491 17.257 19.2839 16.9552 19.3997C16.5582 19.5522 16.0944 19.6228 15.6895 19.7631C15.4305 19.7949 15.2734 19.611 15.2565 19.3406C15.231 18.9348 15.2764 18.4972 15.2569 18.0882C15.3521 17.1224 16.4105 17.2187 17.0474 16.9479H17.0478Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_7475_16672">
          <rect width="28" height="27" fill="currentColor" />
        </clipPath>
      </defs>
    </svg>
  )
})

Iconmark.displayName = 'Iconmark'
